export const colors = {
    primary: '#80E7F2',
    text: '#80E7F2',
    textDark: '#272727',
    textLight: '#FFFFFF',
    headerLight: '#0AEBFF',
    black: '#272727',
    nav: '#43518A',
    footer: '#151515'
}